import { Image, Text, View } from "react-native";

type SnapshotAvatarProps = Readonly<{
	user?: { displayName?: string; profileImageUrl?: string | null };
	size?: number;
}>;


const SnapshotAvatar = ({ user, size = 32 }: SnapshotAvatarProps) => {
	const style = { width: size, height: size, borderRadius: size / 2 };

	if (user?.profileImageUrl) {
		return <Image source={{ uri: user.profileImageUrl }} style={style} />;
	}
	return (
		<View style={style} className="bg-primary items-center justify-center">
			<Text className="text-xs text-chalk font-medium">
				{user?.displayName?.charAt(0)?.toUpperCase() ?? "?"}
			</Text>
		</View>
	);
};

export default SnapshotAvatar;
